import Swiper from 'swiper';

import 'bootstrap';
import 'masonry-layout';
import 'imagesloaded'

export default {
  init() {
    var $ = jQuery;
    let bodyTag = $('body');

    let burger = $('.navbar-header__burger--js'),
        mobileMenu = $('.navbar-content');
    burger.click(function (e) {
      e.preventDefault();
      mobileMenu.slideToggle();
    });

    // init masonry
    if (bodyTag.hasClass('portfolios') || bodyTag.hasClass('portfolio')) {
      var $grid = $('.masonry').masonry({
        itemSelector: '.masonry__item',
        gutter: 32,
        isFitWidth: true,
      });
      // layout Masonry after each image loads
      $grid.imagesLoaded().progress(function () {
        $grid.masonry('layout');
      });
    }
    // logged
    let photoItemLink = $('.masonry__item-overlay--js');
    // top-nav logged
    if (bodyTag.hasClass('logged')) {
      $('.navbar-header__signin').addClass('logged--none');
      $('.header-sign-in').addClass('logged--none');
      $('.extra-links-sign-in').addClass('logged--none');
      $('.extra-links-logged').addClass('logged--block');
      $('.navbar-header__user-img').addClass('logged--block')

      if (window.innerWidth < 1025) { /* mobile*/
        photoItemLink.removeClass('js-open-modal')
      }
    } else {
      $('.navbar-header__signin').removeClass('logged--none');
      $('.header-sign-in').removeClass('logged--none');
      $('.extra-links-mobile .extra-links-sign-in').removeClass('logged--none');
      $('.navbar-header__user-img').removeClass('logged--block')
    }

    // input file on the account page
    function handleFileSelect(evt) {
      var file = evt.target.files; // FileList object
      var f = file[0];
      var reader = new FileReader();
      // Closure to capture the file information.
      reader.onload = (function() {
        return function(e) {
          $('.thumb').attr('src', e.target.result)
        };
      })(f);
      // Read in the image file as a data URL.
      reader.readAsDataURL(f);
    }

    if (bodyTag.hasClass('account-page')) {
      document.querySelector('.account__img').addEventListener('change', handleFileSelect, true);
    }

      let imgDelete = $('.account__delete');
      imgDelete.click(function () {
        $('.thumb').attr('src', 'images/gravatar-150x150.jpg');
        $('.account__img').val('');
    });

      // change psw block make visible
    let changePswd = $('.form-element__change-pswd');
    changePswd.click(function(e) {
      e.preventDefault();
      $('.account__change-pswd-form').slideToggle();
      $(this).addClass('second-link--clicked');
    });

    // show-hide password
    let hidePswBtn = $('.form-element__hide-btn');
    hidePswBtn.click(function() {
        var inputEl = $(this).parent().find($('input'));
        var imgEl = $(this).parent().find($('img'));
        console.log(1);
        var attr = inputEl.attr('type');
        if (attr == 'password') {
          inputEl.attr('type', 'text');
          imgEl.attr('src', 'images/icons/visibility_off-24px-off.svg')
        } else {
          inputEl.attr('type', 'password');
          imgEl.attr('src', 'images/icons/visibility-24px.svg')
        }
      });
    // show errors
    let imgError = $('.form-element--img-error');
    let charNumber = $('.form-element__charnumber'),
        textarea = $('.form-element__textarea'),
        currentValueBlock = $('.form-element__current');
    let submitBtn = $('.submit-btn--js');

    //validation
    // if user decided to change his Username, but left the field blank
    let inputEl = $('.form-element__empty-js');
    let addPhotoForm = $('.add-photo__inputs--js');

    let currentInput = addPhotoForm.find(inputEl);
    currentInput.keyup( function () {
      if ($(this).val().length !== 0) {
        submitBtn.removeAttr('disabled');
        console.log(currentInput)
      }
    });
    // input filled
    inputEl.keyup( function () {
      let emptyField = inputEl.val().length;
      if (emptyField === 0) {
        $(this).addClass('form-element--border-error');
        $(this).parent().find(imgError).addClass('form-element--img-error-visible').next().slideDown();
        submitBtn.attr('disabled', 'true');
      } else {
        $(this).removeClass('form-element--border-error');
        $(this).parent().find(imgError).removeClass('form-element--img-error-visible').next().slideUp();
        submitBtn.removeAttr('disabled');
      }
    });

    // textarea allowed number
    textarea.keyup( function () {
      let current = $(this).val().length;
      let textareaWrap = $(this).parent();
      console.log(current)
      $(this).parent().find(currentValueBlock).text(current);
      if (current > 300) {
        $(this).parent().find(charNumber).addClass('form-element__charnumber--error');
        textareaWrap.next().slideDown();
        textareaWrap.addClass('form-element--border-error');
        textareaWrap.find(imgError).addClass('form-element--img-error-visible');
        submitBtn.attr('disabled', 'true');
      } else {
        $(this).parent().find(charNumber).removeClass('form-element__charnumber--error');
        textareaWrap.next().slideUp();
        textareaWrap.removeClass('form-element--border-error');
        textareaWrap.find(imgError).removeClass('form-element--img-error-visible');
        let emptyFieldGeneral = inputEl.val().length;
        if (emptyFieldGeneral !== 0) {
          submitBtn.removeAttr('disabled');
        }
      }
    });

    // email validation
    // eslint-disable-next-line no-useless-escape
    let emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let email = $('#email');
    email.keyup( function () {
      if (emailReg.test(email.val()) == false) {
        email.addClass('form-element--border-error');
        $(this).parent().find(imgError).addClass('form-element--img-error-visible').next().slideDown();
      } else  {
        email.removeClass('form-element--border-error');
        $(this).parent().find(imgError).removeClass('form-element--img-error-visible').next().slideUp();
      }
    });

    // url validation
    // eslint-disable-next-line no-useless-escape
    let urlReg = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www\.)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
    let url = $('.form-element__url');
    url.keyup( function () {
      if (urlReg.test($(this).val()) == false) {
        $(this).addClass('form-element--border-error');
        $(this).parent().find(imgError).addClass('form-element--img-error-visible').next().slideDown();
      } else {
        $(this).removeClass('form-element--border-error');
        $(this).parent().find(imgError).removeClass('form-element--img-error-visible').next().slideUp();
      }
    });
    url.focusout(function () {
      if (urlReg.test($(this).val()) == false) {
        $(this).val('');
        $(this).removeClass('form-element--border-error');
        $(this).parent().find(imgError).removeClass('form-element--img-error-visible').next().slideUp();
      }
    });

  // confirm password validation
    let newPswd = $('#newpassword'),
        confirm = $('#confirm');
    function pswdWrong() {
      newPswd.addClass('form-element--border-error');
      confirm.addClass('form-element--border-error');
      newPswd.parent().find(imgError).addClass('form-element--img-error-visible');
      confirm.parent().find(imgError).addClass('form-element--img-error-visible').next().slideDown();
      $('.submit-btn').attr('disabled', 'true');
    }
    function pswdRight() {
      confirm.removeClass('form-element--border-error');
      newPswd.removeClass('form-element--border-error');
      newPswd.parent().find(imgError).removeClass('form-element--img-error-visible');
      confirm.parent().find(imgError).removeClass('form-element--img-error-visible').next().slideUp();
      $('.submit-btn').removeAttr('disabled');
    }

      confirm.keyup( function () {
    if (newPswd.val() !== confirm.val()) {
      pswdWrong();
    } else {
      pswdRight();
    }
      newPswd.keyup( function () {
        if (newPswd.val() !== confirm.val()) {
          pswdWrong();
        } else {
          pswdRight();
        }
      });
    });
    // closest micro-library
    !function(e){'function'!=typeof e.matches&&(e.matches=e.msMatchesSelector||e.mozMatchesSelector||e.webkitMatchesSelector||function(e){for(var t=this,o=(t.document||t.ownerDocument).querySelectorAll(e),n=0;o[n]&&o[n]!==t;)++n;return Boolean(o[n])}),'function'!=typeof e.closest&&(e.closest=function(e){for(var t=this;t&&1===t.nodeType;){if(t.matches(e))return t;t=t.parentNode}return null})}(window.Element.prototype);

    //modal windows
      var modalButtons = document.querySelectorAll('.js-open-modal'),
        overlay = document.querySelector('.modal-overlay'),
        overlayLightbox = document.querySelector('.modal-overlay-lightbox'),
        closeButtons = document.querySelectorAll('.js-modal-close'),
        bodyTagJS = document.body,
        closeActive = document.querySelectorAll('.js-close-active'),
        modalWind = document.querySelectorAll('.modal-window'),
        backBTN = document.querySelector('.modal-delete__back-btn--js');
      console.log(modalButtons);

      modalButtons.forEach(function(item){

        item.addEventListener('click', function(e) {

          e.preventDefault();
          var modalId = this.getAttribute('data-modal'),
            modalElem = document.querySelector('.modal-window[data-modal="' + modalId + '"]');
          console.log(modalElem);
          modalElem.classList.add('active');
          if (modalElem.classList.contains('modal-lightbox')) {
            overlayLightbox.classList.add('active');
          } else {
            overlay.classList.add('active');
          }
          bodyTagJS.classList.add('body-hidden');
          $(document).mouseup(function (e){ // событие клика по веб-документу
            var modalLightbox = $('#modal-lightbox'); // тут указываем ID элемента
            var overlaylLightbox = $('.modal-overlay-lightbox--js'); // тут указываем ID элемента
            if (!modalLightbox.is(e.target) // если клик был не по нашему блоку
              && modalLightbox.has(e.target).length === 0) { // и не по его дочерним элементам
              modalLightbox.removeClass('active'); // скрываем его
              overlaylLightbox.removeClass('active'); // скрываем его
            }
          });
        });

      });

      closeButtons.forEach(function(item){
        // eslint-disable-next-line no-unused-vars
        item.addEventListener('click', function(e) {
          let parentModal = this.closest('.modal-window');
          parentModal.classList.remove('active');
          overlay.classList.remove('active');
          overlayLightbox.classList.remove('active');
          bodyTagJS.classList.remove('body-hidden')

        });
      });
    document.body.addEventListener('keyup', function (e) {
      var key = e.key;

      if (key === 'Escape') {
        modalWind.forEach(function(item) {
          item.classList.remove('active');
          overlay.classList.remove('active');
          overlayLightbox.classList.remove('active');
          bodyTagJS.classList.remove('body-hidden')
        });
        // modalWind.classList.remove('active');
        // overlay.classList.remove('active');
        // bodyTagJS.classList.remove('body-hidden')
      }
    }, false);
    backBTN.addEventListener('click', function() {
      modalWind.forEach(function(item) {
        item.classList.remove('active');
        overlay.classList.remove('active');
        bodyTagJS.classList.remove('body-hidden')
      });
    });

    closeActive.forEach(function(item) {
      // eslint-disable-next-line no-unused-vars
      item.addEventListener('click', function() {
        this.closest('.modal-window').classList.remove('active');
        // this.closest(overlay).classList.remove('active');
      });
    });
    overlay.addEventListener('click', function() {
        modalWind.forEach(function(item) {
          item.classList.remove('active');
        });
      console.log(modalWind);
      this.classList.remove('active');
      bodyTagJS.classList.remove('body-hidden')
    });
    // }); // end ready

    //swiper init
    // eslint-disable-next-line no-unused-vars
    var mySwiper = new Swiper ('.modal-lightbox__slider--init-js', {
      // Optional parameters
      loop: true,
      autoHeight: true, //enable auto height
      spaceBetween: 16,
      centeredSlides: true,
      effect: 'fade',
      breakpoints: {
        1024: {
          // loop: false,
          // centeredSlides: true,
          // slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 0,
        },
      },
    });
    $('.modal-lightbox__slider-button-prev--js').click(function() {
      mySwiper.slidePrev();
    });
    $('.modal-lightbox__slider-button-next--js').click(function() {
      mySwiper.slideNext();
    });


    if (bodyTag.hasClass('add-photo')) {


      // add photo modal
      let seriesItem = $('.modal-add__series-item--js');
      let seriesItemInfo = $('.modal-add__info--js');
      let seriesHeading = $('.modal-add__heading');
      seriesItem.click(function () {
        $(this).find(seriesItemInfo).addClass('modal-add__series-item--clicked');
        $(this).find(seriesHeading).addClass('modal-add__series-item-info--clicked');
      });

      let titleModal = $('.modal-add__title--js');
      if (window.innerWidth < 768) { /* mobile*/
        titleModal.text('Add to series')
      }

    }
  },
    // JavaScript to be fired on all pages, after page specific JS is fired
    finalize() {
  },
}

